import * as React from 'react';
import { Dialog, DialogTitle, Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import db from '../database'


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

const ImportDialogue = ({open, handleClose}) =>{
    const [file, setFile] = React.useState(null);
    const [status, setStatus] = React.useState('');

  // Function to handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

  // Function to check if a document with the same title exists
    const checkIfTitleExists = async (title) => {
        try {
        const result = await db.find({
            selector: { title: title },
        });
        return result.docs.length > 0;  // Return true if a document with the title exists
        } catch (error) {
        console.error('Error checking title:', error);
        return false;
        }
    };

    const removeIdAndRev = (doc) => {
        const { _id, _rev, ...docWithoutIdRev } = doc;
        return docWithoutIdRev;
    };
    

  // Function to import the JSON file and add documents to PouchDB
    const importJsonFile = async () => {
        if (!file) {
            setStatus('No file selected');
            return;
        }

        const reader = new FileReader();
        reader.onload = async (event) => {
        try {
            const jsonData = JSON.parse(event.target.result);
            if (!Array.isArray(jsonData)) {
            setStatus('Invalid JSON format');
            return;
            }

            let importedCount = 0;
            for (const doc of jsonData) {
            if (!doc.title) {
                console.warn('Skipping document without a title:', doc);
                continue;  // Skip documents without a title field
            }

            const titleExists = await checkIfTitleExists(doc.title);
            if (titleExists) {
                console.warn('Document with title already exists:', doc.title);
                continue;  // Skip documents with duplicate titles
            }

            const cleanedDoc = removeIdAndRev(doc);
            // Add document to PouchDB
            await db.post(cleanedDoc);
            importedCount++;
            }

            setStatus(`Successfully imported ${importedCount} documents.`);
        } catch (error) {
            console.error('Error importing JSON file:', error);
            setStatus('Error importing file');
        }
        };

        reader.readAsText(file);  // Read the selected file as text
    };

    return (
        <Dialog onClose={handleClose} open={open} fullWidth={true}>
            <DialogTitle>Import to DB</DialogTitle>
            <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 5}}>
                <Button
                    component="label"
                    role={undefined}
                    sx={{mb: 2}}
                    variant="contained"
                    tabIndex={-1}
                >
                    Upload file
                    <VisuallyHiddenInput
                        type="file"
                        onChange={handleFileChange}
                    />
                </Button>
                {file && (<Typography sx={{mb: 2}}>{file.name}</Typography>)}
                {file && (<Button sx={{mb: 2}} variant="contained" onClick={()=>{importJsonFile()}}>Import</Button>)}
                {status && (<Typography>{status}</Typography>)}
            </Box>
        </Dialog>
    )
}


export default ImportDialogue